export const testimonialsSliderOptions = (instance, options) => {
    let onEvents = {}

    return {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        cssMode: false,
        pagination: {
            el: instance.paginationEl,
            type: 'fraction',
            renderFraction: function (currentClass, totalClass) {
                return '<span class="' + currentClass + '"></span>' +
                        ' z ' +
                        '<span class="' + totalClass + '"></span>';
            }
        },
        on: onEvents
    }
}